import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
	imports: [CommonModule, MatSnackBarModule, FontAwesomeModule],
	exports: [FontAwesomeModule],
})
export class CommonUiModule {}
